import React, {useEffect} from "react";
import axios from "axios";
import Box from "@mui/material/Box";
import {
  getAuthorizeURL,
  getBackendURL, getPathAfterBaseUrl, httpResponse,
  httpResponseError
} from "../fn";
import {Link1} from "../domains/common/components/Typography";

const queryParameters = new URLSearchParams(window.location.search)
const urlQueryCode = queryParameters.get("code")
const urlQueryState = queryParameters.get("state")

export const redirectToLogin = () => {
  window.location.replace(getAuthorizeURL());
}

export const redirectToMainPage = () => {
  const url = `/main?f=${getPathAfterBaseUrl()}`
  window.location.replace(url);
}

export const redirectToOauthPage = () => {
  window.location.replace(getAuthorizeURL());
}

export default function OAuthPage() {
  const backendUrl = getBackendURL();
  
  const authUser = async () => {
    const result = await new Promise((resolve) => {
      axios.get(`${backendUrl}/oauth/authentication/?code=${urlQueryCode}`, {
        withCredentials : true,
        headers: {
          'content-type': 'application/json',
        },
      }).then((response) => {
        resolve(httpResponse(response.data))
      }).catch((error) => {
        resolve(httpResponseError(error));
      });
    })
    
    if(!result.ok) {
      window.location.replace('/oauth/error');
    } else {
      if(urlQueryState?.includes('localhost'))
        return
      
      window.location.replace(urlQueryState || '/');
    }
  }
  
  useEffect(()=> authUser(), [])
  
  return (<div></div>)
}

export function OAuthError() {
  return (
    <Box display="flex" height={200}>
      <Box m="auto" sx={{textAlign: 'center'}}>
        Во время авторизации произошла ошибка. Обратитесь к администратору сервиса.
        <p/>
        <Link1 href={getAuthorizeURL()}>Перейти к авторизации</Link1>
      </Box>
    </Box>)
}